import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import { Link as RouterLink } from 'react-router-dom'

import {
  Card,
  CardContent,
  Grid, 
  IconButton, 
  Typography,
} from '@mui/material'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { DataGrid, esES } from '@mui/x-data-grid'
import BulkParents from 'widgets/parents/bulk'
import CreateParent from 'widgets/parents/create'

const Parents = (props) => {
  const { auth, firestore } = useFirebase()
  const { credentials } = auth
  const { director, getDirector, getParentsBySchoolId, parents } = firestore

  const [rows, setRows] = useState([])

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'name', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Nombre'}</b>
      ),
      renderCell: (params) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <b>{params.value}</b>
        </span>
      ),
      minWidth: 240,
      flex: 2,
      hideable: false,
    },
    { 
      field: 'email', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Email'}</b>
      ), 
      minWidth: 240,
      flex: 2,
    },
    { 
      field: 'id',
      headerName: '',
      flex: 0,
      renderCell: (params) => (
        <IconButton component={RouterLink} to={`${params.value}`}>
          <ChevronRightIcon />
        </IconButton>
      ),
      type: 'singleSelect',
      align: 'right',
      sortable: false,
      filterable: false,
      hideable: false,
    },
  ]

  useEffect(() => {
    if (credentials === undefined) return
    getDirector(credentials.uid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credentials])
  
  useEffect(() => {
    if (director === undefined) return
    getParentsBySchoolId(director.schoolId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [director])

  useEffect(() => {
    if (parents === undefined) return

    var data = []
    parents.forEach((parent) => {
      data.push({
        'id': parent['id'],
        'name': parent['name'],
        'email': parent['email'],
      })
    })
    setRows(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parents])

  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Typography color='primary' variant='h4'>
          <b style={{ fontWeight: 900 }}>Padres</b>
        </Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <BulkParents director={director} />
          </Grid>
          <Grid item xs={12}>
            <CreateParent director={director} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={8} lg={9}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>LISTA DE PADRES</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  autoHeight
                  disableSelectionOnClick
                  // disableColumnMenu
                  columns={columns}
                  localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                  pageSize={10}
                  rows={rows}
                  rowsPerPageOptions={[10]}
                  sx={{ borderWidth: 0 }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default Parents